module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.currentIcons.length > 0) ? _c('div', {
    staticClass: "header-icons"
  }, _vm._l((_vm.currentIcons), function(icon, index) {
    return _c('a', {
      staticClass: "header-icon hint--rounded",
      class: _vm.hintPosition(index),
      attrs: {
        "target": "_blank",
        "aria-label": icon.label,
        "href": icon.link
      }
    }, [(icon.icon) ? _c('svg-icon', {
      staticClass: "svg-icon",
      attrs: {
        "name": icon.icon
      }
    }) : _vm._e(), _vm._v(" "), (icon.html) ? _c('span', {
      staticClass: "icon-html",
      domProps: {
        "innerHTML": _vm._s(icon.html)
      }
    }) : _vm._e(), _vm._v(" "), (icon.svgId) ? _c('svg', {
      class: icon.svgClass
    }, [_c('use', {
      attrs: {
        "xlink:href": ("#" + (icon.svgId))
      }
    })]) : _vm._e()], 1)
  })) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-42445d22"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderIcons.vue
// module id = 101
// module chunks = 0